import { SkeletonRow } from '../skeleton';

const PUBLIC_FOOTER_LINK_COUNT = 11;

const FooterSkeleton = () => (
  <footer className='bg-gray-600' aria-hidden='true'>
    <div className='grid gap-3 px-4 py-12 md:grid-cols-3 md:pt-8 md:pb-16'>
      {Array.from({ length: PUBLIC_FOOTER_LINK_COUNT }, (_, index) => (
        <div key={index} className='flex justify-center'>
          <SkeletonRow className='h-5 w-40 max-w-full' />
        </div>
      ))}
    </div>
    <div className='grid place-items-center gap-7 p-4 md:grid-cols-3 md:p-5'>
      <div className='hidden md:block' />
      <div className='flex gap-2'>
        {Array.from({ length: 4 }, (_, index) => (
          <SkeletonRow key={index} className='h-12.5 w-12.5 rounded-full' />
        ))}
      </div>
      <SkeletonRow className='h-5 w-40' />
    </div>
  </footer>
);

export default FooterSkeleton;
